/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "exclamation-point-b64b9d63--sprite",
  "use": "exclamation-point-b64b9d63--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"exclamation-point-b64b9d63--sprite\"><g transform=\"translate(36 36) rotate(180)\"><g transform=\"translate(36 36) rotate(180)\" opacity=\"0\"><g fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0.5\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g></g></g><g transform=\"translate(-30 19.111)\"><g transform=\"translate(46.572 -8.989)\"><g transform=\"translate(0 12.9)\"><path d=\"M-275.874,273.031a1.413,1.413,0,0,1-.422,1.007,1.429,1.429,0,0,1-1.013.422,1.43,1.43,0,0,1-1.013-.422,1.436,1.436,0,0,1-.416-1.007,1.452,1.452,0,0,1,.416-1.013,1.43,1.43,0,0,1,1.013-.422A1.436,1.436,0,0,1-275.874,273.031Z\" transform=\"translate(278.739 -271.596)\" fill=\"currentColor\" /></g><path d=\"M-275.881,244.362l-.715,7.944a.713.713,0,0,1-.715.715.713.713,0,0,1-.715-.715l-.715-7.944a1.431,1.431,0,0,1,1.429-1.435A1.431,1.431,0,0,1-275.881,244.362Z\" transform=\"translate(278.739 -242.927)\" fill=\"currentColor\" /></g></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
